import React from "react";
import { useLang } from "@/i18n/LanguageContext";

export default function Marquee() {
  const { t } = useLang();
  const text = t.marquee;
  return (
    <div className="relative border-y border-white/10 bg-ink-surface/30 py-5 overflow-hidden" aria-hidden="true" data-testid="marquee">
      <div className="marquee-track">
        {[0, 1].map((k) => (
          <span key={k} className="font-mono text-sm md:text-base uppercase tracking-[0.2em] text-white/45 px-4">
            {text.repeat(2)}
          </span>
        ))}
      </div>
    </div>
  );
}
